import script from "./RegisterBereitsRegistriertIndex.vue?vue&type=script&setup=true&lang=js"
export * from "./RegisterBereitsRegistriertIndex.vue?vue&type=script&setup=true&lang=js"

import "./RegisterBereitsRegistriertIndex.vue?vue&type=style&index=0&id=e29c94e2&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-e29c94e2"]])

export default __exports__